import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import autoSaved from '../../utils/hoc/formHelpers/autoSaved';
import WithSuggestions from './hoc/WithSuggestions';
import PureTextField from './TextField';

export const TextField = AsControl()(PureTextField);
export const TextFieldControl = bindControlToForm()(TextField);
export const AutoSavedTextFieldControl = autoSaved({ saveOnBlur: true })(TextFieldControl);

export const TextFieldWithAutoSuggest = AsControl()(WithSuggestions()(PureTextField));
export const TextFieldWithAutoSuggestControl = bindControlToForm()(TextFieldWithAutoSuggest);
export const AutoSavedTextFieldWithAutoSuggestControl = autoSaved({ saveOnBlur: true })(TextFieldWithAutoSuggestControl);
